// extracted by mini-css-extract-plugin
export default {"company-header":"Header_company-header__qGy7m","company-header-item":"Header_company-header-item__7-jZZ"};